import $ from 'jquery';
import Accordion from './accordion';

export default (() => {
    const accordion = new Accordion('#accordion');

    $(document).ready(() => {
        accordion.init();
    });
})();